import { render, staticRenderFns } from "./ContactAttachments.vue?vue&type=template&id=04305429&scoped=true"
import script from "./ContactAttachments.vue?vue&type=script&lang=ts"
export * from "./ContactAttachments.vue?vue&type=script&lang=ts"
import style0 from "./ContactAttachments.vue?vue&type=style&index=0&id=04305429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04305429",
  null
  
)

export default component.exports